function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1324",
  "data-name": "Group 1324",
  transform: "translate(-94.597 -571.097)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Document-File",
  transform: "translate(127.929 579.862)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1290",
  "data-name": "Group 1290",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1289",
  "data-name": "Group 1289"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1287",
  "data-name": "Group 1287"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_775",
  "data-name": "Path 775",
  d: "M62.866,82.1H4.71A1.711,1.711,0,0,1,3,80.391V22.236a1.723,1.723,0,0,1,.5-1.211L24.025.5A1.723,1.723,0,0,1,25.236,0h37.63a1.711,1.711,0,0,1,1.71,1.71V80.391A1.711,1.711,0,0,1,62.866,82.1ZM6.421,78.681H61.155V3.421H25.944L6.421,22.944Z",
  transform: "translate(-3)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1288",
  "data-name": "Group 1288"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_776",
  "data-name": "Path 776",
  d: "M25.236,23.946H4.71a1.71,1.71,0,1,1,0-3.421H23.525V1.71a1.71,1.71,0,0,1,3.421,0V22.236A1.711,1.711,0,0,1,25.236,23.946Z",
  transform: "translate(-3)",
  fill: "#d5d5d5"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1291",
  "data-name": "Group 1291",
  transform: "translate(10.263 27.367)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_777",
  "data-name": "Path 777",
  d: "M45.34,11.421H7.71A1.71,1.71,0,0,1,7.71,8H45.34a1.71,1.71,0,0,1,0,3.421Z",
  transform: "translate(-6 -8)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1292",
  "data-name": "Group 1292",
  transform: "translate(30.788 17.105)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_778",
  "data-name": "Path 778",
  d: "M30.815,8.421H13.71A1.71,1.71,0,0,1,13.71,5h17.1a1.71,1.71,0,0,1,0,3.421Z",
  transform: "translate(-12 -5)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1293",
  "data-name": "Group 1293",
  transform: "translate(10.263 37.63)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_779",
  "data-name": "Path 779",
  d: "M45.34,14.421H7.71A1.71,1.71,0,1,1,7.71,11H45.34a1.71,1.71,0,0,1,0,3.421Z",
  transform: "translate(-6 -11)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1294",
  "data-name": "Group 1294",
  transform: "translate(10.263 47.893)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_780",
  "data-name": "Path 780",
  d: "M45.34,17.421H7.71A1.71,1.71,0,0,1,7.71,14H45.34a1.71,1.71,0,0,1,0,3.421Z",
  transform: "translate(-6 -14)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1295",
  "data-name": "Group 1295",
  transform: "translate(10.263 58.155)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_781",
  "data-name": "Path 781",
  d: "M45.34,20.421H7.71A1.71,1.71,0,0,1,7.71,17H45.34a1.71,1.71,0,0,1,0,3.421Z",
  transform: "translate(-6 -17)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1296",
  "data-name": "Group 1296",
  transform: "translate(10.263 68.418)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_782",
  "data-name": "Path 782",
  d: "M45.34,23.421H7.71A1.71,1.71,0,0,1,7.71,20H45.34a1.71,1.71,0,0,1,0,3.421Z",
  transform: "translate(-6 -20)",
  fill: "#d5d5d5"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1323",
  "data-name": "Group 1323"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  y1: 92.744,
  x2: 120.112,
  transform: "translate(99.562 574.541)",
  fill: "none",
  stroke: "#d5d5d5",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_70",
  "data-name": "Line 70",
  y1: 93.918,
  x2: 121.632,
  transform: "translate(96 572.5)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_774",
  "data-name": "Path 774",
  d: "M0,93.918,121.632,0",
  transform: "translate(100.082 576.582)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
})));

var SvgNoFile = function SvgNoFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128.519,
    height: 100.806,
    viewBox: "0 0 128.519 100.806",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-file.1d16e234.svg";
export { ForwardRef as ReactComponent };